module.exports = __webpack_public_path__ + "img/img1.4f2eb780.jpg";